module.exports = __webpack_public_path__ + "img/comment-like-active-icon.a4369990.svg";